export default function translationFallback(
  translationName: string,
  translation: string,
  fallback: string
): string {
  return translationName === translation ? fallback : translation;
}
